import { Component, PACKAGE_ROOT_URL, OnInit } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../../main/accountant/accountant.service";
import { UntypedFormBuilder, FormGroup, FormControl, Validators, FormsModule } from "@angular/forms";
import { FormUtil } from "../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";
import { TooltipModule } from "ngx-bootstrap/tooltip";

/* This is a component which we pass in modal*/
@Component({
    selector: "chat-settings-modal",
    templateUrl: "./chat-settings-modal.component.html",
    imports: [FormsModule, TooltipModule]
})
export class ChatSettingsModalComponent implements OnInit {
  formUtil: FormUtil;

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private formBuilder: UntypedFormBuilder,
    private toastr: HotToastService
  ) {}

  ngOnInit(): void {}
}
